import { render, staticRenderFns } from "./JcdcNavRouterLinkMobile.vue?vue&type=template&id=3cae789c"
import script from "./JcdcNavRouterLinkMobile.vue?vue&type=script&lang=ts"
export * from "./JcdcNavRouterLinkMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports